<template>
  <li>
    <router-link :class="{ active: isActive }" :to="to" class="hover-item">
      <slot name="name"></slot>
      <span class="icon">
        <slot name="icon"></slot>
      </span>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true
    }
  },
  computed: {
    isActive () {
      if (this.$route.path === this.to) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

a {
  line-height: 55px;
  border-bottom: 1px solid $light-grey;
  padding-left: 25px;
  font-weight: 500;
  display: block;

  &.router-link-active {
    color: $dark-primary;
    background: $light-secondary;
  }
}

.icon {
  float: right;
  display: inline-block;
  width: 70px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/menubar-link.vue